import { ProctorEmbeddedState } from '@/extensionCores/content/store/proctor.type';
import useAuth from '@/hooks/useAuth/useAuth';
import { Box, Text } from '@chakra-ui/react';
import { useState } from 'react';

const HomePage = () => {
  const [proctorState] = useState<ProctorEmbeddedState | undefined>(undefined);

  const { auth } = useAuth();

  console.log('Proctor State in the extension => ', proctorState);
  console.log('Auth => ', auth);
  const welcomeMessage = auth ? (
    <>
      Hello{' '}
      <Box as="span" fontWeight="bold" color={'blue'}>
        {auth.email}
      </Box>
      , welcome to Miva Exam Watch! {'\n'} We are here to support your academic
      integrity throughout the examination process.
    </>
  ) : (
    'Welcome to Miva Exam Watch!'
  );
  return (
    <div>
      <Text fontSize="16px" mb={4} pl="10px" pt="10px">
        {welcomeMessage}
      </Text>
    </div>
  );
};

export default HomePage;
